module.exports = __webpack_public_path__ + "static/media/r216.78105d52.jpg";